var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69181",
    "data-name": "Group 69181",
    transform: "translate(16099 18500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17337",
    "data-name": "Rectangle 17337",
    width: 16,
    height: 16,
    transform: "translate(-16099 -18500)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "silence",
    transform: "translate(-16098 -18499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69178",
    "data-name": "Group 69178",
    transform: "translate(4.733 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69177",
    "data-name": "Group 69177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37382",
    "data-name": "Path 37382",
    d: "M180.018,7.835A2.785,2.785,0,0,1,179.6,6.4v-.82a4.271,4.271,0,0,0-3.719-4.232v-.8a.547.547,0,0,0-1.094,0v.8a4.2,4.2,0,0,0-1.4.436.547.547,0,1,0,.5.972,3.119,3.119,0,0,1,1.4-.349h.1a3.179,3.179,0,0,1,3.115,3.172V6.4a3.869,3.869,0,0,0,.55,1.956.547.547,0,0,0,.962-.521Z",
    transform: "translate(-173.095 -0.001)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69180",
    "data-name": "Group 69180",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69179",
    "data-name": "Group 69179",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37383",
    "data-name": "Path 37383",
    d: "M13.84,13.067.934.161A.547.547,0,0,0,.16.934L3.075,3.849a4.211,4.211,0,0,0-.368,1.729V6.4a3.3,3.3,0,0,1-.6,1.777,6.645,6.645,0,0,0-.893,2.24A1.641,1.641,0,0,0,2.827,12.36H5.343a1.641,1.641,0,0,0,3.281,0h2.5a1.642,1.642,0,0,0,.407-.051l1.531,1.531a.547.547,0,0,0,.773-.773Zm-6.857-.16a.547.547,0,0,1-.547-.547H7.53A.547.547,0,0,1,6.983,12.907ZM2.827,11.266a.547.547,0,0,1-.537-.649,5.643,5.643,0,0,1,.767-1.9A4.326,4.326,0,0,0,3.8,6.4v-.82A3.132,3.132,0,0,1,3.926,4.7l6.567,6.567Z",
    transform: "translate(0 -0.001)",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOff);
export default __webpack_public_path__ + "static/media/bell-off.34adb020e20d210d58097f47c2b3a12d.svg";
export { ForwardRef as ReactComponent };